module.exports = __webpack_public_path__ + "static/media/Tier_2.ee2a23a0.svg";